export default "__VITE_ASSET__1f3c4346__"